import React, { Component } from "react";
import { connect } from "react-redux";
import { ls } from "../../locale";
import { Button, Modal } from "react-bootstrap";
import { getAgentPath, jsonHelper, jumpTo } from "../../helpers";
import dayjs from 'dayjs';

import { isInAppBrowser, stringFormatter } from "../../helpers";

// ducks
import { bookingActions } from "../../state/ducks/booking";
import { sessionActions } from "../../state/ducks/session";

import Baggages from "./Baggages";
import Meals from "./Meals";
import Insurance from './Service/Insurance';
import CarryOnBags from "./Service/CarryOnBags";
import Service from "./Service"

import CounterLogo from "../../images/counter-checkin.png"
import PriorityLogo from "../../images/priority-checkin.png"
import ExpressBagLogo from "../../images/express-bag.png"
import InsuranceLogo from "../../images/tune.png"

import { numberFormatter } from "../../helpers";

import "./index.scss";
import BasePageWithStatusBar from "../../components/BasePage/BasePageWithStatusBar";
import { pushSelectExtraEvent } from "../../helpers/dataLayer";
import { findAddedService, findAddedServiceAll, getSelectedServices, getServiceList } from "./helpers";
import OversizedItems from "./Service/OversizedItems";
import { AirportService } from "./Service/AirportService";
import { SectionTitle } from "../../comps/section-title";



class ExtraPage extends Component {

  mealSelection = React.createRef()

  constructor(props) {
    super(props);
    this.state = {
      isShowInsuranceConfirmation: false,
      isShowMessageBox: false,
      showOversizedItems: false,
    };
  }

  componentDidMount() {
    this.props.getAncillaries().then(() => {
      this.props.getBookingWithSummary();
    });

  }

  selectBag = async (flightId, passengerId, bagSSRCode) => {
    await this.props.addBaggage(flightId, passengerId, bagSSRCode);
    const response = await this.props.getBookingWithSummary();
    
    const addedServices = findAddedService(response.booking, 'baggages', [{ logicalFlightId: flightId, passengerId, ssrCode: bagSSRCode }]);
    pushSelectExtraEvent({addedServices, category: 'baggage', currency: response.booking?.currencyCode || 'OMR'});
  };

  clearBag = (flightId, passengerId, ssrCode) => {
    this.props.removeBaggage(flightId, passengerId, ssrCode)
      .then(() => {
        this.props.getBookingWithSummary();
      });
  };

  selectMeals = async selected => {
    await this.props.changeMeals(selected);
    const response = await this.props.getBookingWithSummary();

    const addedServices = findAddedService(response.booking, 'meals', selected);
    pushSelectExtraEvent({addedServices, category: 'meal', currency: response.booking?.currencyCode || 'OMR'});
  };


  continue = () => {

    const { booking, ancillaries } = this.props;
    const selectedServices = getSelectedServices({ booking, ancillaries });

    if (!selectedServices.allMealSelected) {
      const rError = ls.t('ExtraPage.Error');
      const rCommon = ls.t('Common');

      let flights = [];

      selectedServices.segments.forEach(segment => {
        if (segment.allMealSelected) return;
        flights.push(`${segment.originCity} - ${segment.destinationCity}`);
      })
      flights = flights.join(` ${rCommon.And} `);

      const message = stringFormatter.formatString(rError.FreeMeal, flights);
      this.showMealMessageBox(message);
      return;
    }

    const bookingMode = booking.bookingMode;
    let nextPage = ""
    if (bookingMode === "MMB")
      nextPage = "/mmb/summary";
    else if (bookingMode === "WCI")
      nextPage = "/wci/seats";
    else
      nextPage = "/seats";

    jumpTo(getAgentPath() + nextPage);
  };

  goBack = () => {
    const bookingMode = this.props.booking.bookingMode;

    let nextPage = '';
    if (bookingMode === "MMB")
      nextPage = "/mmb/summary";
    else if (bookingMode === "WCI")
      nextPage = "/wci/passenger";
    else
      nextPage = "/flights";

    jumpTo(getAgentPath() + nextPage);
  };

  addInsurance = async () => {
    const booking = this.props.booking;
    if (booking && booking.bookingMode === 'MMB' && Array.isArray(booking.passengers)) {
      let invalidDob = false;
      booking.passengers.forEach(pax => {
        const dob = dayjs(pax.dateOfBirth);
        const diff = dayjs().diff(dob, 'year');
        if (diff > 100) {
          invalidDob = true;
          return;
        }
      });

      if (invalidDob) {
        this.showMessageBox();
        return;
      }
    }

    await this.props.addInsurance();
    const response = await this.props.getBookingWithSummary();

    const addedServices = findAddedServiceAll(response.booking, 'insurances');
    pushSelectExtraEvent({addedServices, category: 'insurance', currency: response.booking?.currencyCode || 'OMR'});
  }

  removeInsurance = async () => {

    this.closeInsuranceConfirmation();

    await this.props.removeInsurance();
    await this.props.getBookingWithSummary();
  }


  addLounge = async (logicalFlightId, ssrCode) => {
    //console.log('add lounge to ', logicalFlightId)
    await this.props.addLounge(logicalFlightId, ssrCode);
    const response = await this.props.getBookingWithSummary();

    const addedServices = findAddedServiceAll(response.booking, 'lounges', logicalFlightId);
    pushSelectExtraEvent({addedServices, category: 'lounge', currency: response.booking?.currencyCode || 'OMR'});
  }

  removeLounge = async (logicalFlightId, ssrCode) => {
    await this.props.removeLounge(logicalFlightId, ssrCode);
    await this.props.getBookingWithSummary();
  }

  addHotel = async (logicalFlightId, ssrCode) => {
    await this.props.addHotel(logicalFlightId, ssrCode);
    const response = await this.props.getBookingWithSummary();

    const addedServices = findAddedServiceAll(response.booking, 'hotels', logicalFlightId);
    pushSelectExtraEvent({addedServices, category: 'hotel', currency: response.booking?.currencyCode || 'OMR'});
  }

  removeHotel = async (logicalFlightId, ssrCode) => {
    await this.props.removeHotel(logicalFlightId, ssrCode);
    await this.props.getBookingWithSummary();
  }

  addExpressBag = async logicalFlightId => {
    //console.log('add lounge to ', logicalFlightId)
    await this.props.addExpressBag(logicalFlightId);
    const response = await this.props.getBookingWithSummary();

    const addedServices = findAddedServiceAll(response.booking, 'expressBags', logicalFlightId);
    pushSelectExtraEvent({addedServices, category: 'expressBags', currency: response.booking?.currencyCode || 'OMR'});
  }

  removeExpressBag = async logicalFlightId => {
    await this.props.removeExpressBag(logicalFlightId)
    await this.props.getBookingWithSummary()
  }

  addCounterCheckin = async logicalFlightId => {
    await this.props.addCounterCheckin(logicalFlightId);
    const response = await this.props.getBookingWithSummary();

    const addedServices = findAddedServiceAll(response.booking, 'counterCheckin');
    pushSelectExtraEvent({addedServices, category: 'counter-checkin', currency: response.booking?.currencyCode || 'OMR'});
  }

  removeCounterCheckin = async logicalFlightId => {
    await this.props.removeCounterCheckin(logicalFlightId)
    await this.props.getBookingWithSummary()
  }

  addPriorityCheckin = async logicalFlightId => {
    await this.props.addPriorityCheckin(logicalFlightId);
    const response = await this.props.getBookingWithSummary();

    const addedServices = findAddedServiceAll(response.booking, 'priorityCheckin');
    pushSelectExtraEvent({addedServices, category: 'priority-checkin', currency: response.booking?.currencyCode || 'OMR'});
  }

  removePriorityCheckin = async logicalFlightId => {
    await this.props.removePriorityCheckin(logicalFlightId)
    await this.props.getBookingWithSummary()
  }

  addCarryOnBags = async request => {
    await this.props.addCarryOnBags(request);
    const response = await this.props.getBookingWithSummary();

    const addedServices = findAddedServiceAll(response.booking, 'carryOnBags', request?.logicalFlightId);
    pushSelectExtraEvent({addedServices, category: 'carryOnBags', currency: response.booking?.currencyCode || 'OMR'});
  }

  removeCarryOnBags = async request => {
    await this.props.removeCarryOnBags(request)
    await this.props.getBookingWithSummary();
  }


  addOversizedItems = async request => {
    await this.props.addOversizedItems(request);
    const response = await this.props.getBookingWithSummary();

    const addedServices = findAddedServiceAll(response.booking, 'oversizedItems', request?.logicalFlightId);
    pushSelectExtraEvent({addedServices, category: 'oversizedItems', currency: response.booking?.currencyCode || 'OMR'});
  }

  removeOversizedItems = async request => {
    await this.props.removeOversizedItems(request)
    await this.props.getBookingWithSummary();
  }

  closeInsuranceConfirmation = () => {
    this.setState({
      isShowInsuranceConfirmation: false,
    });
  };

  showInsuranceConfirmation = () => {
    this.setState({
      isShowInsuranceConfirmation: true,
    });
  };

  closeMessageBox = () => {
    this.setState({
      isShowMessageBox: false
    });
  };

  showMessageBox = () => {
    this.setState({
      isShowMessageBox: true
    });
  };

  showMealMessageBox = message => {
    this.setState({
      isShowMealMessageBox: true,
      mealMessage: message,
    })
  }

  closeMealMessageBox = () => {
    this.setState({
      isShowMealMessageBox: false,
      mealMessage: null
    })
    if(this.mealSelection.current) 
      this.mealSelection.current.showMealsSelection(true)
  }

  handleToggleOversizedItems = (checked) => {
    this.setState({ showOversizedItems: checked });
  }

  handleToggleLounge = (checked) => {
    this.setState({ showLounge: checked });
  }

  handleToggleHotel = (checked) => {
    this.setState({ showHotel: checked });
  }

  render() {

    const rExtraPage = ls.t('ExtraPage');
    if (!rExtraPage.Baggage) return null;

    const { booking, bookingSummary, ancillaries } = this.props;

    const selection = getSelection(booking, ancillaries);
    const insurance = getInsurance(booking, ancillaries);
    const lounges = getServiceList('lounges', booking, ancillaries);
    const hotels = getServiceList('hotels', booking, ancillaries);
    const expressBags = getServiceList('expressBags', booking, ancillaries);
    const counterCheckin = getServiceList('counterCheckin', booking, ancillaries);
    const priority = getServiceList('priorityCheckin', booking, ancillaries);

    const hasOversizedItemsSelected = hasServiceSelected('oversizedItems', booking);
    const hasLoungeSelected = hasServiceSelected('lounges', booking);
    const hasHotelSelected = hasServiceSelected('hotels', booking);

    const currencyCode = booking.currencyCode;
    const total = (booking.bookingMode === "Booking" ? bookingSummary.bookingTotal : booking.reservationBalance) || 0;
    const amountSplit = numberFormatter.decimalSplitter(numberFormatter.formatCurrency(total));

    const hideInsurance = false; // userData && userData.userType === UserType.agent;

    const inAppBrowser = isInAppBrowser();

    const rButton = ls.t('Button');
    const rCommon = ls.t('Common');
    const rMessageBox = ls.t('MessageBox');
    const rSalamAir = ls.t('SalamAir');

    const rInsurance = rExtraPage.Insurance;
    const rConfirm = rInsurance.Confirm;
    const insuranceMore = stringFormatter.formatString(rInsurance.More, `<a href="${rInsurance.Link}" target="_blank">${rCommon.More}</a>`);
    const rCovers = rExtraPage.Insurance.Covers.split(/[\r\n]/);

    const hasID00 = booking.segments?.some(s => s.fares[0].fareTypeName === 'ID00');

    const counterConfirmation = {
      message: rExtraPage.CounterConfirm?.Message.split(/[\r\n]/) ?? [],
      cancelButtonText: rExtraPage.CounterConfirm?.CancelText,
      closeButtonText: rExtraPage.CounterConfirm?.CloseText,
      confirmOnCancel: true,
    }

    return (
      <>
        <BasePageWithStatusBar hasSummary statusLabel="extra" onItemClick={item => jumpTo(getAgentPath() + '/' + item)}>
          <div className="min-height extra-page">
            <SectionTitle title={rExtraPage.Baggage.Label} />
            <Baggages selection={selection} onSelectBag={this.selectBag} onClearBag={this.clearBag}
              currencyCode={booking.currencyCode} />
            <CarryOnBags
              passengers={booking.passengers}
              ancillaries={ancillaries}
              currencyCode={booking?.currencyCode}
              onSelectService={this.addCarryOnBags}
              onClearService={this.removeCarryOnBags}
            />
            <OversizedItems
              hasItems={this.state.showOversizedItems || hasOversizedItemsSelected}
              passengers={booking.passengers}
              ancillaries={ancillaries}
              currencyCode={booking.currencyCode}
              onSelectService={this.addOversizedItems}
              onClearService={this.removeOversizedItems}
              onToggle={this.handleToggleOversizedItems}
            />
            <Service services={expressBags}
              addService={this.addExpressBag}
              removeService={this.removeExpressBag}
              logoSrc={ExpressBagLogo}
              logoAlt="Express Bag Access"
              serviceText={rExtraPage.ExpressBag}
            />

            <SectionTitle title="Travel Extras" />
            <Service services={counterCheckin}
              addService={this.addCounterCheckin}
              removeService={this.removeCounterCheckin}
              logoSrc={CounterLogo}
              logoAlt="Counter Check-in Access"
              serviceText={rExtraPage.CounterCheckin}
              removeConfirmation={counterConfirmation}
            />
            <Service services={priority}
              addService={this.addPriorityCheckin}
              removeService={this.removePriorityCheckin}
              logoSrc={PriorityLogo}
              logoAlt="Priority Check-in"
              serviceText={rExtraPage.PriorityCheckin}
            />  
            {!hasID00 && <Meals ref={this.mealSelection}
              booking={this.props.booking}
              bookingSummary={this.props.bookingSummary}
              selection={selection}
              onSelectMeals={this.selectMeals}
              currencyCode={booking.currencyCode} 
            />}
            {!hideInsurance && <Insurance services={insurance?.service ? [insurance] : []}
              addService={this.addInsurance}
              removeService={this.showInsuranceConfirmation} 
              logoSrc={InsuranceLogo}
              logoAlt="Travel Insurance"
              serviceText={rExtraPage.Insurance}
            />}
            <AirportService
              resourceKey="ExtraPage.Lounge"
              icon="/images/lounge.png"
              hasItems={ this.state.showLounge || hasLoungeSelected}
              services={lounges}
              onSelectService={this.addLounge}
              onClearService={this.removeLounge}
              onToggle={this.handleToggleLounge}
            />

            <AirportService
              resourceKey="ExtraPage.Hotel"
              icon="/images/hotel.png"
              hasItems={ this.state.showHotel || hasHotelSelected}
              services={hotels}
              onSelectService={this.addHotel}
              onClearService={this.removeHotel}
              onToggle={this.handleToggleHotel}
            />


            <div className="clearfix btnCon extra-page-total">
              {!inAppBrowser && <Button type="submit" className="btn btn-primary pull-left flip btn-cancel btn-effect"
                onClick={() => this.goBack()}>
                <span><i className="picon picon-btn-arrow-left-w" />{rButton.Back}</span>
              </Button>}
              <Button type="submit" className="btn btn-primary pull-right flip btn-submit btn-effect"
                onClick={() => this.continue()}><span>{rButton.Continue}
                  <i className="picon picon-btn-arrow-right-w" /></span>
              </Button>
              <div className="bottom-total pull-right">
                <label>{rCommon.BookingTotal}</label>
                <p>
                  <span className="currency">{currencyCode} </span>
                  {amountSplit.amount}
                  <span className={`${currencyCode} decimal-point`}>
                    {
                      numberFormatter.oneDecimalPoint(amountSplit.decimal, currencyCode)
                    }
                  </span>
                </p>
              </div>
            </div>
          </div>
        </BasePageWithStatusBar>
        <Modal className={ls.t("rootClass")} show={this.state.isShowInsuranceConfirmation}>
          <Modal.Header>
            <Modal.Title>{rMessageBox.Title.Confirmation}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>{rConfirm}</h5>
            <ul>
              {rCovers.map((cover, index) => <li key={index}>{cover}</li>)}
              <li dangerouslySetInnerHTML={{ __html: insuranceMore }}></li>
            </ul>
            {/* <p dangerouslySetInnerHTML={{__html: insuranceMore}} /> */}
            <p>{rInsurance.TNCApply}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.removeInsurance}>{rExtraPage.Insurance.RemoveInsurance}</Button>
            <Button onClick={this.closeInsuranceConfirmation}>{rExtraPage.Insurance.KeepInsurance}</Button>
          </Modal.Footer>
        </Modal>
        <Modal className={ls.t("rootClass")} show={this.state.isShowMessageBox} onHide={this.closeMessageBox} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>{rMessageBox.Title.Warning}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{rSalamAir.Greeting}</p>
            <p>{rInsurance.InvalidDOB}</p>
            <p>{rSalamAir.Email}<br />{rSalamAir.Phone}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeMessageBox}>{rButton.Close}</Button>
          </Modal.Footer>
        </Modal>
        <Modal className={ls.t("rootClass")} show={this.state.isShowMealMessageBox} onHide={this.closeMealMessageBox} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>{rMessageBox.Title.Warning}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{this.state.mealMessage}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeMealMessageBox}>{rButton.Close}</Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}


function getSelection (booking, ancillaries) {
  const result = [];
  if (!booking || !Array.isArray(booking.segments)) return result;
  if (!ancillaries || !Array.isArray(ancillaries)) return result;

  ancillaries.forEach(seg => {
    const segment = booking.segments.find(s => s && s.logicalFlightId === seg.logicalFlightId);
    if (!segment || !segment.permissions || !segment.permissions.canChangeExtras) return;

    const passengers = []
    seg.passengers.forEach(pax => {
      const passenger = booking.passengers.find(p => p.id === pax.passengerId);
      if(!passenger) return;

      const selectedMeals = Array.isArray(passenger.meals) && passenger.meals.filter(x => x.logicalFlightId === seg.logicalFlightId);
      const selectedBaggages = Array.isArray(passenger.baggages) && passenger.baggages.filter(x => x.logicalFlightId === seg.logicalFlightId);
      const selectedInsurances = Array.isArray(passenger.insurances) && passenger.insurances.filter(x => x.logicalFlightId === seg.logicalFlightId);
      passengers.push({
        ...pax,
        selectedMeals,
        selectedBaggages,
        selectedInsurances,
        id: passenger.id,
        firstName: passenger.firstName,
        lastName: passenger.lastName,
        paxType: passenger.paxType,
        paxTypeName: passenger.paxTypeName,
        paxIndex: passenger.paxIndex,
      });
    });

    result.push({
      trip: segment.direction,
      origin: segment.originCode,
      destination: segment.destinationCode,
      originCity: segment.originCity,
      destinationCity: segment.destinationCity,
      departureDate: segment.departureDate,
      arrivalDate: segment.arrivalDate,
      logicalFlightId: segment.logicalFlightId,
      passengers
    });
  });

  return result;
}

function getInsurance(booking, ancillaries) {
  const result = {};

  if (!booking || !Array.isArray(booking.segments) || !booking.segments.length) return result;
  if (!booking.segments.find(x => x && x.permissions && x.permissions.canChangeExtras)) return result;

  if (!booking || !Array.isArray(booking.passengers)) return result;
  if (!Array.isArray(ancillaries) || !ancillaries.length) return result;

  let service = null;
  ancillaries.forEach(ancil => {
    if (!Array.isArray(ancil.passengers) || !ancil.passengers.length) return;
    ancil.passengers.forEach(pax => {
      if (!Array.isArray(pax.insurances) || !pax.insurances.length) return;

      if (!service)
        service = jsonHelper.cloneDeep(pax.insurances[0]);
      else
        service.amount += pax.insurances[0].amount;
    })
  });

  // const passenger = ancillaries[0].passengers[0];
  // const service = Array.isArray(passenger.insurances) && passenger.insurances.length > 0 ? passenger.insurances[0] : null;

  return {
    service,
    passengerCount: booking.passengers.length,
    currencyCode: booking.currencyCode,
  }
}

function hasServiceSelected(key, booking) {
  if (!booking || !Array.isArray(booking.passengers)) return false;

  return booking.passengers.some(passenger => {
    return Array.isArray(passenger[key]) && passenger[key].length > 0;
  });
}

function mapStateToProps(state) {
  return {
    booking: state.booking.details,
    bookingSummary: state.booking.summary,
    ancillaries: state.booking.ancillaries
  };
}

const mapDispatchToProps = {
  ...bookingActions,
  getUserData: sessionActions.getUserData
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtraPage);

